import { all, put, select } from 'redux-saga/effects';
import { actions, StoreState } from '../store/utils';
import { takeLatest, processEvery, takeEvery } from '../utils/apiActions';
import * as Api from '../api';
import { Room } from '../model'

const onLogin = takeLatest(actions.loggedIn, function* ({ time, localRooms, login }) {
   if (login.data && login.data.device?.home === 'DisplayBoard') {
      return
   }

   for (const email of localRooms) {
      yield put(actions.fetchScheduleRequest(time, email));
   }

});

const onRoomsFetched = takeEvery(actions.fetchRooms.response, function* (state, rooms): IterableIterator<any> {
   console.log('Rooms fetched: ', rooms);
   const checkinResource: any = yield select((s: StoreState) => s.checkinResource)
   if (Array.isArray(rooms) && rooms.length > 0 && typeof checkinResource === 'string' && checkinResource) {
      // find a room that has email matching checkinResource
       const matchedRoom = rooms.find((room: Room) => room.emailAddress.toLowerCase() === (checkinResource as string).toLowerCase());
      if (matchedRoom) {
         // You can dispatch an action or handle the matched room as needed
         yield put(actions.pickLocation(matchedRoom.location));
      }
   }
})


export default all([
   onLogin,
   onRoomsFetched,
   processEvery(actions.fetchRooms, Api.fetchRooms)
]);
